module.exports = __webpack_public_path__ + "static/media/two_monkey_cuttingwood.346d91d7.png";